import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    :root {
        --bottom-bar-height-mobile: env(safe-area-inset-bottom, 0px);
    }
  `;
